import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatDialogModule } from '@angular/material/dialog';
import { AppComponent } from '@app/app.component';
import { AdminNotificationsEffects } from '@app/state/admin-state/admin-notifications.effects';
import { AdminRewardsEffects } from '@app/state/admin-state/admin-rewards.effects';
import { AdminUsersEffects } from '@app/state/admin-state/admin-users.effects';
import { adminReducerCreator } from '@app/state/admin-state/admin.reducer';
import { ApiEffects } from '@app/state/app-state/api.effects';
import { reducer } from '@app/state/app-state/app.reducer';
import { ModalEffects } from '@app/state/app-state/modal.effects';
import { NavigationEffects } from '@app/state/app-state/navigation.effects';
import { MerchantEffects } from '@app/state/merchant-state/effects/merchant.effects';
import { OrdersEffects } from '@app/state/merchant-state/effects/orders.effects';
import { StockEffects } from '@app/state/merchant-state/effects/stock/stock.effects';
import { StoreEffects } from '@app/state/merchant-state/effects/store.effects';
import { merchantReducerCreator } from '@app/state/merchant-state/reducers/merchant.reducer';
import { KodypayCommonModule } from '@common/kodypay-common.module';
import { CoreModule } from '@core/core.module';
import { FEATURE_FLAG_INITIALIZER } from '@core/feature-flags/providers/feature-flag-app-initializer.provider';
import { environment } from '@env/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { LOADING_BAR_CONFIG, LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { FormsModule } from '@shared/forms/forms.module';
import { QrModule } from '@shared/qr/qr.module';
import { NgxCurrencyDirective, NgxCurrencyInputMode, provideEnvironmentNgxCurrency } from 'ngx-currency';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { httpInterceptProviders } from './core/authentication/interceptors/authentication.interceptor';
import { INTERCOM_INITIALIZER } from './core/intercom/providers/intercom-initializer.provider';
import { AuthenticationEffects } from './core/store/authentication/effects/authentication.effects';
import { GraphQLModule } from './graphql.module';
import { AdminKodypayAppSettingsEffects } from './state/admin-state/admin-kodypay-app-settings/admin-kodypay-app-settings.effects';
import { AdminMerchantsMerchantEffects } from './state/admin-state/admin-merchants-merchant-info.effects';
import { MenuCategoriesEffects } from './state/merchant-state/effects/menu-categories/menu-categories.effects';

export const customCurrencyMaskConfig = {
  align: 'left',
  allowNegative: false,
  allowZero: true,
  decimal: '.',
  precision: 2,
  prefix: '£ ',
  suffix: '',
  thousands: ',',
  nullable: true,
  min: 0,
  max: null,
  inputMode: NgxCurrencyInputMode.Natural,
};

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    KodypayCommonModule,
    GraphQLModule,
    StoreModule.forRoot({ appState: reducer, adminState: adminReducerCreator, merchantState: merchantReducerCreator }),
    EffectsModule.forRoot([
      ApiEffects,
      NavigationEffects,
      ModalEffects,
      AdminUsersEffects,
      AdminNotificationsEffects,
      AdminRewardsEffects,
      MerchantEffects,
      StockEffects,
      StoreEffects,
      OrdersEffects,
      MenuCategoriesEffects,
      AdminMerchantsMerchantEffects,
      AdminKodypayAppSettingsEffects,
      AuthenticationEffects,
    ]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production, connectInZone: true }),
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    AppRoutingModule,
    CoreModule,
    QrModule,
    FormsModule,
    MatDialogModule,
    NgxCurrencyDirective,
    LoadingBarModule,
  ],
  providers: [
    httpInterceptProviders,
    { provide: LOADING_BAR_CONFIG, useValue: { latencyThreshold: 100 } },
    FEATURE_FLAG_INITIALIZER,
    provideEnvironmentNgxCurrency(customCurrencyMaskConfig),
    INTERCOM_INITIALIZER,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
